import { SwitchBackgroundProcessorOptions } from 'features/VirtualBackground/source';
import { selectActiveProcessorInfo } from '../state/selectors/virtualBackground';
import { ProcessorInfo } from '../types';
import { AssetPaths, IBackgroundProcessorConfigProvider } from '../types/backgroundProcessor';
import { getOptionsFromProcessorInfo } from '../utils/backgroundProcessor';
import { getAssetPaths } from '../utils/assetPaths';

export class StoreBasedConfigProvider implements IBackgroundProcessorConfigProvider {
    public getProcessorInfo(): ProcessorInfo | null {
        return selectActiveProcessorInfo();
    }

    public getProcessorOptions(): SwitchBackgroundProcessorOptions | null {
        const info = this.getProcessorInfo();
        if (!info) return null;

        return getOptionsFromProcessorInfo(info);
    }

    public getAssetPaths(): AssetPaths {
        return getAssetPaths();
    }
}
